import xhr from './xhr'
import urlUtils from './url'

export default function (options) {
	options.url = options.url || urlUtils.getUrl(options.path, options.pathParams, options.queryParams);
	return xhr(options);
}


// WEBPACK FOOTER //
// ../common/utils/http/http.js